import { TableRowDto } from '@asset-metrix/portal-gateway-client-js';
import { dateFormatter } from '@asset-metrix/portal-ui';
import { JsonSchema } from '@sagold/react-json-editor';
import { isString } from 'lodash';

import { extractValue } from '../table/extractValue';

export function getInitialData(schema: JsonSchema, data: TableRowDto['data']) {
  return Object.fromEntries(
    Object.entries(schema.properties ?? {})
      .map(([key, property]) => {
        if (typeof property === 'boolean') {
          return [key, data[key]];
        }

        const pointer =
          typeof property.options?.dataPointer === 'string'
            ? property.options.dataPointer
            : key;
        let value = extractValue(pointer, data, true);

        // Apply dateFormatter for readonly dates
        if (
          property.format === 'date' &&
          property.options?.readOnly &&
          isString(property.options?.dateFormat)
        ) {
          const dateFormat = property.options?.dateFormat;
          value = dateFormatter(value, { dateFormat });
        }

        return [
          key,
          property.type === 'array' && !Array.isArray(value)
            ? value === undefined
              ? []
              : [value]
            : value,
        ];
      })
      // Make sure there are no props with undefined values, because they cannot be included in a JSON anyway
      .filter(([, propertyValue]) => propertyValue !== undefined)
  );
}
